import { AppComponent } from "./../app.component";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BrowserService } from "../service/browser.service";
import {
  ActionSheetController,
  AlertController,
} from "@ionic/angular";
import { UtilityService } from "../service/utility.service";
import { ApiService } from "../service/api.service";
@Component({
  selector: "app-home",
  templateUrl: "tab2.page.html",
  styleUrls: ["tab2.page.scss"],
})
export class Tab2Page implements OnInit {
  public AppRef = AppComponent;

  public util = UtilityService;
  
  address_exist = false;
  
  constructor(
    private router: Router,
    public br: BrowserService,
    public actionSheetController: ActionSheetController,
    public alertCtrl: AlertController,
    public utility: UtilityService,
    private api: ApiService
  ) {}

  async ngOnInit() {
    window["isUpdateAvailable"].then(async (isAvailable) => {
      if (isAvailable) {
        const getTostValue = this.utility.presentToast(this.AppRef.content.toast_msg[this.AppRef.currentLang]['update']);
        getTostValue.then( value => {
          if(value === 'cancel') {
            window.location.reload();
          }
        })
      }
    });

    // check if address exist
    this.address_exist = this.utility.checkAddressInStorage()
  }

  map() {
    this.router.navigate(["/map"]);
  }

  barometer() {
    this.router.navigate(["/barometer"]);
  }

  logout() {
    this.utility.deleteUser()
  }

  async login() {
    const actionSheet = await this.alertCtrl.create({
      header: this.AppRef.content.home[this.AppRef.currentLang]["login"],
      inputs: [
        {
          type: "text",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "pass_key"
          ],
          value: "",
        },
        {
          type: "password",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "password"
          ],
          value: "",
        },
      ],
      buttons: [
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["cancel"],
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["login"],
          handler: (data) => {
            // console.log(data);
            if (data[0] == "" || data[1] == "") {
              this.utility.presentToast(this.AppRef.content.toast_msg[this.AppRef.currentLang]["oops_msg"]);
            } else {
              this.api.login(data[0], data[1])
            }
          },
        },
      ],
    });
    await actionSheet.present();
  }

  async sync() {
    const actionSheet = await this.alertCtrl.create({
      header: this.AppRef.content.home[this.AppRef.currentLang]["sync"],
      inputs: [
        {
          type: "text",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "mnemonic"
          ],
          value: "",
        },
        {
          type: "password",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "password"
          ],
          value: "",
        },
      ],
      buttons: [
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["cancel"],
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["sync"],
          handler: (data) => {
            // console.log(data);
            if (data[0] == "" || data[1] == "") {
              this.utility.presentToast(this.AppRef.content.toast_msg[this.AppRef.currentLang]["oops_msg"]);
            } else {
              this.api.sync(data[0], data[1])
            }
          },
        },
      ],
    });
    await actionSheet.present();
  }

  async createAccount() {
    const actionSheet = await this.alertCtrl.create({
      header: this.AppRef.content.home[this.AppRef.currentLang][
        "createAccount"
      ],
      backdropDismiss: false,
      inputs: [
        {
          type: "password",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "password"
          ],
          value: "",
        },
        {
          type: "password",
          placeholder: this.AppRef.content.home[this.AppRef.currentLang][
            "confirm_password"
          ],
          value: "",
        },
      ],
      buttons: [
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["cancel"],
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["create"],
          handler: (data) => {
            // console.log(data);
            if (data[0] === "" || data[1] === "") {
              this.utility.presentToast(this.AppRef.content.toast_msg[this.AppRef.currentLang]["oops_msg"]);
              this.createAccount();
              return;
            }

            if (data[0] !== data[1]) {
              this.utility.presentToast(this.AppRef.content.toast_msg[this.AppRef.currentLang]["wrong_pass"]);
              this.createAccount();
              return;
            }
            this.api.create(data[0]);
          },
        },
      ],
    });
    await actionSheet.present();
  }

  async questionSection() {
    const actionSheet = await this.alertCtrl.create({
      header: this.AppRef.content.home[this.AppRef.currentLang][
        "diseaseSelect"
      ],
      inputs: [
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["covid"],
          value: "Covid",
        },
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["tbA"],
          value: "TbA"
        },
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["tbC"],
          value: "TbC",
        },
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["tbP"],
          value: "TbP",
        },
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["hepatitis"],
          value: "Hepatitis",
        },
        {
          type: "radio",
          label: this.AppRef.content.home[this.AppRef.currentLang]["hiv"],
          value: "Hiv",
        },
      ],
      buttons: [
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["cancel"],
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.AppRef.content.home[this.AppRef.currentLang]["okay"],
          handler: (data) => {
            this.router.navigate(["/questions"], {
              queryParams: { value: data },
            });
          },
        },
      ],
    });
    await actionSheet.present();
  }
}
